import request from '@request'

export function getCurTypeTrain(uid) {
  return request({
    url: '/train/list/' + uid,
    method: 'get',
  })
}

export function getAllTrainList() {
  return request({
    url: '/train/mapping',
    method: 'get',
  })
}

export function saveTrainRecord(params) {
  return request({
    url: '/train/records',
    method: 'post',
    data: params,
  })
}

// 获取当日训练时长
export function getDailyTrainTime() {
  return request({
    url: '/train/records/day',
    method: 'get',
  })
}

// 获取当日训练时长
export function getSingleTrainTime() {
  return request({
    url: '/train/records/single',
    method: 'get',
  })
}

/**
 * 获取训练记录
 */
export function getTrainRecord() {
  return request({ url: '/train/records', method: 'get' })
}

/**
 * 获取续费列表
 */
export function getRenewalList() {
  return request({ url: 'prices', method: 'get' })
}

/**
 * 支付宝支付
 */
export function aliPay(priceId) {
  return request({
    url: '/payment/alipay',
    method: 'post',
    data: {
      priceId,
      source: 'ejj-web',
      payType: 'native',
    },
  })
}

/**
 * 微信支付
 */
export function wechatPay(priceId) {
  return request({
    url: '/payment/wxpay',
    method: 'post',
    data: {
      priceId,
      source: 'ejj-web',
      payType: 'native',
    },
  })
}

/**
 * 支付状态查询
 */
export function getPayStatus(id) {
  return request({
    url: `/payment${id ? '/' + id : ''}/task`,
    method: 'get',
  })
}

/**
 * 保存训练加载时间
 */
export function postLoadTime(data) {
  return request({
    url: `/train/records`,
    method: 'post',
    data: {
      trainId: data.trainId,
      startTime: data.startTime,
      endTime: data.endTime,
    },
  })
}
